export default __webpack_public_path__ + "static/media/diem-den-pho-bien-02.8f7a6189.png";